const subItemsSignature = (subItems = []) =>
	[...subItems]
		.map(s => `${s.itemId || ''}::${s.name || ''}::${s.quantity || 0}::${s.price || 0}::${s.status || ''}::${subItemsSignature(s.items)}`)
		.sort()
		.join('|')

const dishCourseKey = (dc) => (dc?.index ?? null)

const isSameGroup = (a, b) =>
	a.itemId === b.itemId
	&& a.type === b.type
	&& a.name === b.name
	&& (a.price ?? 0) === (b.price ?? 0)
	&& (a.remark ?? null) === (b.remark ?? null)
	&& dishCourseKey(a.dishCourse) === dishCourseKey(b.dishCourse)
	&& (a.status ?? null) === (b.status ?? null)
	&& subItemsSignature(a.items) === subItemsSignature(b.items)

export const recalcOrder = (items = []) => {
	return items.reduce((res, el) => {
		let groupIndex = res.findIndex(x => isSameGroup(x, el))

		if (groupIndex === -1) {
			return [...res, {
				...el,
				quantity: el.quantity,
				itemPositionIds: [el.itemPositionId],
				itemPositionId: el.itemPositionId
			}]
		} else {
			let updatedItem = {
				...res[groupIndex],
				quantity: res[groupIndex].quantity + el.quantity,
				itemPositionIds: [...res[groupIndex].itemPositionIds, el.itemPositionId]
			}
			return [
				...res.slice(0, groupIndex),
				updatedItem,
				...res.slice(groupIndex + 1)
			]
		}
	}, [])
}
